import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { NavLink, withRouter } from "react-router-dom";
// core components
import MUIDataTable from "mui-datatables";
import Grid from "@material-ui/core/Grid";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import { fetchCCTVReport, fetchCctvactreportbycomp } from "../../api/portal";
import { fetchVessellName } from "../../api/vessellist";
import { pushLoader } from "../../actions/main";
import { pushCctvhistoris, pushCctvMap } from "../../actions/dashboard";
import Warning from "@material-ui/icons/Warning";
import Info from "@material-ui/icons/Timelapse";
import ReactExport from "assets/libs/react-export-excel";
import Button from "components/CustomButtons/Button.jsx";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const fileName = `CCTV Report ${moment().format("LLL")}`;

class cctvReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cctvReport: [],
      data: [],
      loader: false,
      vesselName: "",
      column: [],
      dataset: []
    };
  }

  UNSAFE_componentWillMount() {
    this.props.pushLoader(true);
    this.setState({ loader: true });

    fetchCctvactreportbycomp()
      .then(response => {
        let data = response.data;

        let dataVessel = [];
        let dataexcel = [];
        if (response != null) {
          data.results.map(e => {
            dataVessel.push({
              vessel: e.shipname,
              callsign: e.callsign,
              type: e.tipe,
              ch1: e.ch1,
              ch2: e.ch2,
              ch3: e.ch3,
              ch4: e.ch4,
              ch5: e.ch5,
              ch6: e.ch6,
              vessel_owner: e.vessel_owner
            });
            // dataexcel.push({
            //   vessel: e.shipname,
            //   callsign: e.callsign,
            //   type: e.tipe,
            //   ch1: this.handleDate(e.ch1),
            //   ch2: this.handleDate(e.ch2),
            //   ch3: this.handleDate(e.ch3),
            //   ch4: this.handleDate(e.ch4),
            //   ch5: this.handleDate(e.ch5)
            // })
            dataexcel.push([
              {
                value: e.shipname,
                style: {
                  alignment: {
                    wrapText: true,
                    vertical: "center",
                    horizontal: "center"
                  }
                }
              },
              {
                value: e.callsign,
                style: {
                  alignment: {
                    wrapText: true,
                    vertical: "center",
                    horizontal: "center"
                  }
                }
              },
              {
                value: e.tipe,
                style: {
                  alignment: {
                    wrapText: true,
                    vertical: "center",
                    horizontal: "center"
                  }
                }
              },
              // {value: e.shipname},
              // {value: e.callsign},
              // {value: e.tipe},
              this.handleValue(e.ch1),
              this.handleValue(e.ch2),
              this.handleValue(e.ch3),
              this.handleValue(e.ch4),
              this.handleValue(e.ch5),
              this.handleValue(e.ch6),
              {
                value: e.vessel_owner,
                style: {
                  alignment: {
                    wrapText: true,
                    vertical: "center",
                    horizontal: "center"
                  }
                }
              }
            ]);
          });
        }

        // this.setState({ cctvReport: dataVessel, loader: false, dataset: dataexcel });
        this.setState({ cctvReport: dataVessel, loader: false });
        this.state.dataset.push({
          columns: [
            "Name", //pixels widthPx
            "Call Sign",
            "Type",
            "AJG",
            "BRT",
            "CCR",
            "ECR",
            "WKN",
            "WKR",
            "Vessel Owner"
          ],
          data: dataexcel
        });
        this.props.pushLoader(false);
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  handleDate = e => {
    let update = new Date();
    let today = moment(update).format("YYYY-MM-DD");
    let day = today.split("-").join("");
    let a = "" + e;
    if (a.includes(day)) {
      let fix = `${a.substring(6, 8) +
        "-" +
        a.substring(4, 6) +
        "-" +
        a.substring(0, 4) +
        " " +
        a.substring(8, 10) +
        ":" +
        a.substring(10, 12) +
        ":" +
        a.substring(12, 14)}`;
      return fix;
    } else if (a !== "undefined") {
      let fix = `${a.substring(6, 8) +
        "-" +
        a.substring(4, 6) +
        "-" +
        a.substring(0, 4) +
        " " +
        a.substring(8, 10) +
        ":" +
        a.substring(10, 12) +
        ":" +
        a.substring(12, 14)}`;
      return fix;
    } else {
      return "Not Avaliable";
    }
  };
  handleValue = e => {
    let update = new Date();
    let today = moment(update).format("YYYY-MM-DD");
    let day = today.split("-").join("");
    let a = "" + e;
    if (a.includes(day)) {
      let fix = `${a.substring(6, 8) +
        "-" +
        a.substring(4, 6) +
        "-" +
        a.substring(0, 4) +
        " " +
        a.substring(8, 10) +
        ":" +
        a.substring(10, 12)}`;
      return {
        value: fix,
        style: {
          fill: { patternType: "solid", fgColor: { rgb: "92d14f" } },
          alignment: {
            wrapText: true,
            vertical: "center",
            horizontal: "center"
          }
        }
      };
    } else if (a !== "undefined") {
      let fix = `${a.substring(6, 8) +
        "-" +
        a.substring(4, 6) +
        "-" +
        a.substring(0, 4) +
        " " +
        a.substring(8, 10) +
        ":" +
        a.substring(10, 12)}`;
      return {
        value: fix,
        style: {
          fill: { patternType: "solid", fgColor: { rgb: "fdff03" } },
          alignment: {
            wrapText: true,
            vertical: "center",
            horizontal: "center"
          }
        }
      };
    } else {
      return {
        value: "Not Avaliable",
        style: {
          fill: { patternType: "solid", fgColor: { rgb: "ff6600" } },
          alignment: {
            wrapText: true,
            vertical: "center",
            horizontal: "center"
          }
        }
      };
    }
  };

  render() {
    const { classes } = this.props;
    const columns = [
      {
        name: "vessel",
        label: "Name",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <NavLink
                  to={"/cctv-history"}
                  onClick={() => {
                    this.props.pushCctvMap([]);
                    let start = [
                      tableMeta.rowData[3],
                      tableMeta.rowData[4],
                      tableMeta.rowData[5],
                      tableMeta.rowData[6],
                      tableMeta.rowData[7],
                      tableMeta.rowData[8]
                    ];
                    start.sort((a, b) => a - b);
                    let end = [
                      tableMeta.rowData[3],
                      tableMeta.rowData[4],
                      tableMeta.rowData[5],
                      tableMeta.rowData[6],
                      tableMeta.rowData[7],
                      tableMeta.rowData[8]
                    ];
                    end.sort((a, b) => b - a);
                    if (start[0] !== "undefined") {
                      this.props.pushCctvhistoris([
                        value,
                        tableMeta.rowData[1],
                        start[0],
                        end[0]
                      ]);
                    } else {
                      this.props.pushCctvhistoris([
                        value,
                        tableMeta.rowData[1],
                        start[1],
                        end[1]
                      ]);
                    }
                  }}
                >
                  <span>{value}</span>
                </NavLink>
              </div>
            );
          }
        }
      },
      {
        name: "callsign",
        label: "Call Sign",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "type",
        label: "Type",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "ch1",
        label: "AJG",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let update = new Date();
            let today = moment(update).format("YYYY-MM-DD");
            let day = today.split("-").join("");
            let a = "" + value;
            if (a.includes(day)) {
              return (
                <span>
                  {" "}
                  {a.substring(6, 8) +
                    "-" +
                    a.substring(4, 6) +
                    "-" +
                    a.substring(0, 4) +
                    " " +
                    a.substring(8, 10) +
                    ":" +
                    a.substring(10, 12)}{" "}
                </span>
              );
            } else if (a !== "undefined") {
              return (
                <span>
                  <Info color="action" />{" "}
                  {a.substring(6, 8) +
                    "-" +
                    a.substring(4, 6) +
                    "-" +
                    a.substring(0, 4) +
                    " " +
                    a.substring(8, 10) +
                    ":" +
                    a.substring(10, 12)}{" "}
                </span>
              );
            } else {
              return (
                <span>
                  <Warning color="error" />
                  not available
                </span>
              );
            }
          }
        }
      },
      {
        name: "ch2",
        label: "BRT",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let update = new Date();
            let today = moment(update).format("YYYY-MM-DD");
            let day = today.split("-").join("");
            let a = "" + value;
            if (a.includes(day)) {
              return (
                <span>
                  {" "}
                  {a.substring(6, 8) +
                    "-" +
                    a.substring(4, 6) +
                    "-" +
                    a.substring(0, 4) +
                    " " +
                    a.substring(8, 10) +
                    ":" +
                    a.substring(10, 12)}{" "}
                </span>
              );
            } else if (a !== "undefined") {
              return (
                <span>
                  <Info color="action" />{" "}
                  {a.substring(6, 8) +
                    "-" +
                    a.substring(4, 6) +
                    "-" +
                    a.substring(0, 4) +
                    " " +
                    a.substring(8, 10) +
                    ":" +
                    a.substring(10, 12)}{" "}
                </span>
              );
            } else {
              return (
                <span>
                  <Warning color="error" />
                  not available
                </span>
              );
            }
          }
        }
      },
      {
        name: "ch3",
        label: "CCR",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let update = new Date();
            let today = moment(update).format("YYYY-MM-DD");
            let day = today.split("-").join("");
            let a = "" + value;
            if (a.includes(day)) {
              return (
                <span>
                  {" "}
                  {a.substring(6, 8) +
                    "-" +
                    a.substring(4, 6) +
                    "-" +
                    a.substring(0, 4) +
                    " " +
                    a.substring(8, 10) +
                    ":" +
                    a.substring(10, 12)}{" "}
                </span>
              );
            } else if (a !== "undefined") {
              return (
                <span>
                  <Info color="action" />{" "}
                  {a.substring(6, 8) +
                    "-" +
                    a.substring(4, 6) +
                    "-" +
                    a.substring(0, 4) +
                    " " +
                    a.substring(8, 10) +
                    ":" +
                    a.substring(10, 12)}{" "}
                </span>
              );
            } else {
              return (
                <span>
                  <Warning color="error" />
                  not available
                </span>
              );
            }
          }
        }
      },
      {
        name: "ch4",
        label: "ECR",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let update = new Date();
            let today = moment(update).format("YYYY-MM-DD");
            let day = today.split("-").join("");
            let a = "" + value;
            if (a.includes(day)) {
              return (
                <span>
                  {" "}
                  {a.substring(6, 8) +
                    "-" +
                    a.substring(4, 6) +
                    "-" +
                    a.substring(0, 4) +
                    " " +
                    a.substring(8, 10) +
                    ":" +
                    a.substring(10, 12)}{" "}
                </span>
              );
            } else if (a !== "undefined") {
              return (
                <span>
                  <Info color="action" />{" "}
                  {a.substring(6, 8) +
                    "-" +
                    a.substring(4, 6) +
                    "-" +
                    a.substring(0, 4) +
                    " " +
                    a.substring(8, 10) +
                    ":" +
                    a.substring(10, 12)}{" "}
                </span>
              );
            } else {
              return (
                <span>
                  <Warning color="error" />
                  not available
                </span>
              );
            }
          }
        }
      },
      {
        name: "ch5",
        label: "WKN",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let update = new Date();
            let today = moment(update).format("YYYY-MM-DD");
            let day = today.split("-").join("");
            let a = "" + value;
            if (a.includes(day)) {
              return (
                <span>
                  {" "}
                  {a.substring(6, 8) +
                    "-" +
                    a.substring(4, 6) +
                    "-" +
                    a.substring(0, 4) +
                    " " +
                    a.substring(8, 10) +
                    ":" +
                    a.substring(10, 12)}{" "}
                </span>
              );
            } else if (a !== "undefined") {
              return (
                <span>
                  <Info color="action" />{" "}
                  {a.substring(6, 8) +
                    "-" +
                    a.substring(4, 6) +
                    "-" +
                    a.substring(0, 4) +
                    " " +
                    a.substring(8, 10) +
                    ":" +
                    a.substring(10, 12)}{" "}
                </span>
              );
            } else {
              return (
                <span>
                  <Warning color="error" />
                  not available
                </span>
              );
            }
          }
        }
      },
      {
        name: "ch6",
        label: "WKR",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let update = new Date();
            let today = moment(update).format("YYYY-MM-DD");
            let day = today.split("-").join("");
            let a = "" + value;
            if (a.includes(day)) {
              return (
                <span>
                  {" "}
                  {a.substring(6, 8) +
                    "-" +
                    a.substring(4, 6) +
                    "-" +
                    a.substring(0, 4) +
                    " " +
                    a.substring(8, 10) +
                    ":" +
                    a.substring(10, 12)}{" "}
                </span>
              );
            } else if (a !== "undefined") {
              return (
                <span>
                  <Info color="action" />{" "}
                  {a.substring(6, 8) +
                    "-" +
                    a.substring(4, 6) +
                    "-" +
                    a.substring(0, 4) +
                    " " +
                    a.substring(8, 10) +
                    ":" +
                    a.substring(10, 12)}{" "}
                </span>
              );
            } else {
              return (
                <span>
                  <Warning color="error" />
                  not available
                </span>
              );
            }
          }
        }
      },
      {
        name: "vessel_owner",
        label: "Vessel Owner",
        options: {
          filter: false,
          display: true
        }
      },
    ];

    const options = {
      filter: false,
      search: true,
      selectableRows: false,
      print: true,
      rowsPerPage: 100,
      responsive: "scroll",
      viewColumns: false,
      // rowsPerPage: [5],
      // rowsPerPageOptions: [5, 10, 15],
      textLabels: {
        body: {
          noMatch: this.state.loader
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      }
    };

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div style={{ justifyContent: "center" }}>
              <Typography
                style={{
                  textAlign: "center",
                  flex: 1,
                  fontSize: "28px",
                  fontWeight: 500
                }}
              >
                <font>CCTV Last Update Report</font>
              </Typography>
              <CustomLinearProgress
                variant="determinate"
                color="gray"
                value={0}
                style={{ width: "40%", display: "inline-block" }}
              />
              <CustomLinearProgress
                variant="determinate"
                color="info"
                value={100}
                style={{ width: "20%", display: "inline-block" }}
              />
              <CustomLinearProgress
                variant="determinate"
                color="gray"
                value={0}
                style={{ width: "40%", display: "inline-block" }}
              />
              <br />
            </div>
          </GridItem>
          <Grid item xs={12}>
            <Grid container justify="center" spacing={2}>
              <Grid item xs={10}>
                <ExcelFile
                  element={
                    <Button
                      color="primary"
                      variant="contained"
                      disabled={this.state.loader}
                      // onClick={() => console.log(this.state.dataset)}
                    >
                      Download as .xlsx
                    </Button>
                  }
                  filename={`${fileName}`}
                  fileExtension="xlsx"
                >
                  <ExcelSheet dataSet={this.state.dataset} name="Sheet 1">
                    {/* <ExcelColumn label="Name" value="vessel" />
                    <ExcelColumn label="Call Sign" value="callsign" />
                    <ExcelColumn label="Type" value="type" />
                    <ExcelColumn label="BRT" value="ch1"/>
                    <ExcelColumn label="WKN" value="ch2" />
                    <ExcelColumn label="WKR" value="ch3" />
                    <ExcelColumn label="AJG" value="ch4" />
                    <ExcelColumn label="CCR" value="ch5" /> */}
                  </ExcelSheet>
                </ExcelFile>
              </Grid>
              <GridItem xs={12} md={10}>
                <br />
                <MUIDataTable
                  data={this.state.cctvReport}
                  columns={columns}
                  options={options}
                />
              </GridItem>
            </Grid>
          </Grid>
        </GridContainer>
      </div>
    );
  }
}

cctvReport.propTypes = {
  pushLoader: PropTypes.bool,
  pushCctvhistoris: PropTypes.array,
  pushCctvMap: PropTypes.array
};

function mapStateToProps(state) {
  return {
    blocking: state.loader
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    pushLoader,
    pushCctvhistoris,
    pushCctvMap
  }
)(cctvReport));
